import { BodyText, Button, DisplayText } from "@classdojo/web/nessie";
import { ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";
import { IconChevronLeft } from "@web-monorepo/dds-icons";
import { AT } from "@web-monorepo/vite-auto-translate-plugin/runtime";
import welcome from "src/pods/help/assets/bitmap@2x.png";

export default function WhatIsDojoCast() {
  return (
    <section sx={pageStyle()}>
      <div sx={imageContainerStyle}>
        <Button
          data-name="what_is_dojo_cast:material_icon"
          sx={backButtonStyle}
          onClick={() => window.history.back()}
          kind="tertiary"
          icon={<IconChevronLeft size="m" />}
        />
        <img src={welcome} sx={imageStyle} />
      </div>
      <DisplayText level={3} as="h1" sx={{ marginX: "auto", marginY: "dt_l" }}>
        <AT>DojoCast</AT>
      </DisplayText>
      <BodyText sx={{ width: "100%" }} textAlign="center">
        Toolkit's magic happens when you log into the ClassDojo website from a computer or smartboard. With DojoCast,
        every time you use a tool in the app - like Timer, Directions, or Think Pair Share - it's automatically
        projected in front of the class. Don't want to display? Just tap "stop DojoCast". So step away from your desk.
        You're now free to move about the classroom :)
      </BodyText>
    </section>
  );
}

const imageStyle: ThemeUIStyleObject = {
  width: "50%",
  height: "50%",
  objectFit: "contain",
  objectPosition: "center center",
  marginX: "auto",
  maxWidth: 340,
};

const backButtonStyle: ThemeUIStyleObject = {
  position: "absolute",
  top: "0",
  left: "0",
  color: "dt_content_light",
  margin: "dt_l",
};

const imageContainerStyle: ThemeUIStyleObject = {
  display: "flex",
  flexDirection: "row",
  alignItems: "flex-start",
};

function pageStyle(): ThemeUIStyleObject {
  return {
    display: "flex",
    flexDirection: "column",
    width: "100vw",
    height: "100vh",
    backgroundColor: "dt_background_primary",
    padding: "dt_l",
  };
}
